import { pisciculture } from "./services"

export const images = {
    sliderImage: require("../assets/images/login/SliderImage.png"),
    loginLogo: require("../assets/images/login/login-image.png"),
    mobileNumberIcon: require("../assets/images/login/user icon.png"),
    viewPassword: require("../assets/images/login/view-password.png"),
    googleIcon: require("../assets/images/login/google.png"),
    appleIcon: require("../assets/images/login/apple.png"),
    signupLogo: require("../assets/images/login/Signup-image.png"),
    mobileIcon: require("../assets/images/login/mobile-icon.png"),
    emailIcon: require("../assets/images/login/email-icon.png"),
    forgotPasswordLogo: require("../assets/images/login/forgot-password-image.png"),
    twoStepLogo: require("../assets/images/login/two-step-image.png"),
    viewIcon: require("../assets/images/login/EyeIcon.png"),
    eyecloseIcon: require("../assets/images/login/EyecloseIcon.png"),
    sliderImage: require("../assets/images/login/SliderImage.png"),
    logo: require("../assets/images/login/NicraLogo.png"),
    sliderBackground: require("../assets/images/login/slider-background.png")
}

export const dashboardIcon = {
    dashboardIcon: require("../assets/images/Dashboard/DashboardIcon.png"),
    farmerIcon: require("../assets/images/Dashboard/FarmersIcon.png"),
    taskAssign: require("../assets/images/Dashboard/TaskAssignIcon.png"),
    collectorListIcon: require("../assets/images/Dashboard/CollectorIcon.png"),
    ReportIcon: require("../assets/images/Dashboard/ReportIcon.png"),
    RegionIcon: require("../assets/images/Dashboard/RegionIcon.png"),
    nicra: require("../assets/images/Dashboard/Nicra.png"),
    totalFarmer: require("../assets/images/Dashboard/TotalFarmer.png"),
    totalTask: require("../assets/images/Dashboard/TaskAssign.png"),
    totalData: require("../assets/images/Dashboard/TotalData.png"),
    userAvatar: require("../assets/images/Dashboard/userImage.png"),
    userImage: require("../assets/images/Dashboard/image.png"),
    editIcon: require("../assets/images/Dashboard/Edit icon.png"),
    userManagementIcon: require("../assets/images/Dashboard/userManagementIcon.png"),
    cropsIcon: require("../assets/images/Dashboard/cropsIcon.png"),
    livestockIcon: require("../assets/images/Dashboard/livestockIcon.png"),
    piscicultureIcon: require("../assets/images/Dashboard/piscicultureIcon.png"),
    machineryIcon: require("../assets/images/Dashboard/machineryIcon.png"),
    certificationIcon: require("../assets/images/Dashboard/certificationIcon.png"),
    trainingIcon: require("../assets/images/Dashboard/trainingIcon.png"),
    whoSponsoredIcon: require("../assets/images/Dashboard/whoSponsorIcon.png"),
    livestock : require("../assets/images/Dashboard/livestock.png"),
    pisciculture : require("../assets/images/Dashboard/pisciculture.png"),
    certification : require("../assets/images/Dashboard/certification.png"),
    trainingProgram: require("../assets/images/Dashboard/training.png"),
    sponsoredImgae: require("../assets/images/Dashboard/sponsoredImg.png"),
    machineryImage:require("../assets/images/Dashboard/machinery.png"),
    datePicker: require("../assets/images/Dashboard/datePickerIcon.png"),
    profileImage: require("../assets/images/Dashboard/Profile.jpg"),
    profile : require("../assets/images/Dashboard/profile-image.jpg"),
}

export const farmers = {
    farmerIcon: require("../assets/images/Farmers/farmer-icon.png"),
    excelSheetIcon: require("../assets/images/Farmers/excel-sheet-image.png"),
    pdfIcon: require("../assets/images/Farmers/pdf-image.png"),
    filterIcon: require("../assets/images/Farmers/filter-image.png"),
    farmerImage1: require("../assets/images/Farmers/FarmersImages/farmer image (1).png"),
    farmerImage2: require("../assets/images/Farmers/FarmersImages/farmer image (2).png"),
    farmerDetailsImage: require("../assets/images/Farmers/farmer-details-image.png"),
    locationDetailsImage: require("../assets/images/Farmers/location-details.png"),
    galleryImage1: require("../assets/images/Farmers/ImageGallery/image-1.png"),
    galleryImage2: require("../assets/images/Farmers/ImageGallery/image-2.png"),
    galleryImage3: require("../assets/images/Farmers/ImageGallery/image-3.png"),
    galleryImage4: require("../assets/images/Farmers/ImageGallery/image-4.png"),
    galleryImage5: require("../assets/images/Farmers/ImageGallery/image-5.png"),
    galleryImage6: require("../assets/images/Farmers/ImageGallery/image-6.png"),
    rightArrow: require("../assets/images/Farmers/ImageGallery/right-arrow.png"),
    leftArrow: require("../assets/images/Farmers/ImageGallery/left-arrow.png"),
    cancelIcon: require("../assets/images/Farmers/ImageGallery/cancel-icon.png"),
    noData : require("../assets/images/Farmers/noData.png"),
}

export const taskAssign = {
    union: require("../assets/images/TaskAssignment/Union.png"),
    filter: require("../assets/images/TaskAssignment/filterimage.png"),
    backArrow: require("../assets/images/TaskAssignment/Back-arrow.png"),
    taskDetail: require("../assets/images/TaskAssignment/Task-detail.png"),
    closeIcon: require("../assets/images/TaskAssignment/Close-icon.png"),
    reportSub: require("../assets/images/TaskAssignment/ReportSub.png"),
    collector: require("../assets/images/TaskAssignment/collector.png")
}

export const region = {
    region: require("../assets/images/Region/region.png"),
    delete: require("../assets/images/Region/delete.png"),
    editIcon: require("../assets/images/Region/edit.png"),
    deleteIcon: require("../assets/images/Region/deleteIcon.png"),
    correct: require("../assets/images/Region/correct.png"),
    browseImage: require("../assets/images/Region/browse.png")
}

export const crops = {
    crops: require("../assets/images/Crops/crops.png")
}

export const userManagement = {
    userManagementIcon: require("../assets/images/Dashboard/Union (1).png")
}